import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { pickerSlotProps, getPresetDates } from './telemetryUtils';

const PRESETS = [
  { key: 'today', label: 'Today' },
  { key: 'week', label: 'This Week' },
  { key: 'month', label: 'This Month' },
  { key: '90days', label: 'Last 90 Days' },
  { key: 'custom', label: 'Custom' },
];

const TYPE_OPTIONS = [
  { key: 'all', label: 'All' },
  { key: 'video', label: 'Video' },
  { key: 'presentation', label: 'Presentation' },
];

const DateRangeFilter = ({
  preset,
  setPreset,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onApply,
  showTypeToggle = false,
  typeFilter,
  setTypeFilter,
  showUserFilter = false,
  userIdFilter,
  setUserIdFilter,
}) => {
  const handlePresetClick = (key) => {
    setPreset(key);
    if (key !== 'custom') {
      const { start, end } = getPresetDates(key);
      setStartDate(start);
      setEndDate(end);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="telemetry-filters">
        <div className="filter-presets">
          {PRESETS.map((p) => (
            <button
              key={p.key}
              className={`filter-preset-btn${preset === p.key ? ' active' : ''}`}
              onClick={() => handlePresetClick(p.key)}
            >
              {p.label}
            </button>
          ))}
        </div>

        {preset === 'custom' && (
          <div className="filter-dates">
            <DateTimePicker
              value={startDate}
              onChange={(val) => setStartDate(val)}
              format="DD/MM/YYYY HH:mm"
              ampm={false}
              slotProps={pickerSlotProps}
            />
            <span className="filter-date-sep">to</span>
            <DateTimePicker
              value={endDate}
              onChange={(val) => setEndDate(val)}
              format="DD/MM/YYYY HH:mm"
              ampm={false}
              minDateTime={startDate}
              slotProps={pickerSlotProps}
            />
          </div>
        )}

        {showUserFilter && (
          <div className="filter-user">
            <div className="filter-user-input-wrapper">
              <SearchIcon className="filter-user-icon" sx={{ fontSize: '1rem' }} />
              <input
                type="text"
                placeholder="Filter by user ID..."
                value={userIdFilter || ''}
                onChange={(e) => setUserIdFilter(e.target.value)}
                className="filter-user-input"
              />
              {userIdFilter && (
                <button className="filter-user-clear" onClick={() => setUserIdFilter('')}>
                  <CloseIcon sx={{ fontSize: '0.875rem' }} />
                </button>
              )}
            </div>
          </div>
        )}

        {showTypeToggle && (
          <div className="filter-type">
            {TYPE_OPTIONS.map((opt) => (
              <button
                key={opt.key}
                className={`filter-type-btn${typeFilter === opt.key ? ' active' : ''}`}
                onClick={() => setTypeFilter(opt.key)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        )}

        <button className="btn btn-primary filter-apply-btn" onClick={onApply}>
          Apply
        </button>
      </div>
    </LocalizationProvider>
  );
};

export default DateRangeFilter;
